export default __webpack_public_path__ + "multi.html?197ad98a90612f9458d14df3530b7490";